import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eb1b53f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { style: {"margin-right":"3rem"} }
const _hoisted_4 = { class: "shop-body" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "item-label" }
const _hoisted_8 = { class: "item-price-holder" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "item-price-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_item_purchase_overlay = _resolveComponent("item-purchase-overlay")!
  const _component_item_description_overlay = _resolveComponent("item-description-overlay")!
  const _component_close_button = _resolveComponent("close-button")!
  const _component_gem_counter = _resolveComponent("gem-counter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.activePurchase)
      ? (_openBlock(), _createBlock(_component_item_purchase_overlay, {
          key: 0,
          "shop-item": _ctx.activePurchase,
          inventory: _ctx.inventory,
          onExit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activePurchase = null))
        }, null, 8, ["shop-item", "inventory"]))
      : _createCommentVNode("", true),
    (_ctx.descriptionItem)
      ? (_openBlock(), _createBlock(_component_item_description_overlay, {
          key: 1,
          item: _ctx.descriptionItem,
          onExit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.descriptionItemId = ''))
        }, null, 8, ["item"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_close_button, { onClicked: _ctx.exit }, null, 8, ["onClicked"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_gem_counter, {
            icon: "primogem.webp",
            text: _ctx.inventory.primos,
            "plus-sign": "",
            outline: "",
            nobackground: "",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.descriptionItemId = 'primogem'))
          }, null, 8, ["text"])
        ]),
        _createVNode(_component_gem_counter, {
          icon: "starglitter.webp",
          text: _ctx.inventory.starglitter,
          outline: "",
          nobackground: "",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.descriptionItemId = 'starglitter'))
        }, null, 8, ["text"]),
        _createVNode(_component_gem_counter, {
          icon: "stardust.webp",
          text: _ctx.inventory.stardust,
          outline: "",
          nobackground: "",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.descriptionItemId = 'stardust'))
        }, null, 8, ["text"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shopList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("div", {
              style: _normalizeStyle(_ctx.cssColours(_ctx.ItemDatabase[item.id])),
              class: "shop-item-holder",
              onClick: ($event: any) => (_ctx.activePurchase = item)
            }, [
              _createElementVNode("img", {
                src: require(`@/assets/images/${item.id}.webp`),
                class: "item-img"
              }, null, 8, _hoisted_6),
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.ItemDatabase[item.id].name), 1),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("img", {
                  class: "cost-item-img",
                  src: require(`@/assets/images/${item.cost[0].id}.webp`)
                }, null, 8, _hoisted_9),
                _createElementVNode("p", _hoisted_10, _toDisplayString(item.cost[0].quantity), 1)
              ])
            ], 12, _hoisted_5)
          ]))
        }), 128))
      ])
    ])
  ], 64))
}